<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoiceMultiple from '$components/Form/PrettyChoiceMultiple.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const projectTypeOptions = [
        `Construction de bâtiment`,
        `Ouvrage d'art (pont, barrage, etc.)`,
        `Route ou infrastructure`,
        `Aménagement foncier ou lotissement`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const projectStageOptions = [
        `Avant-projet (études préliminaires)`,
        `En phase de conception`,
        `En phase de construction`,
        `Projet existant à diagnostiquer ou expertiser`,
        `Je ne sais pas`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const serviceTypesOptions = [
        `Étude de sol / étude géotechnique`,
        `Essais de laboratoire (béton, sol, matériaux)`,
        `Contrôle qualité chantier`,
        `Carottage, sondage ou forage`,
        `Audit énergétique ou plomberie sanitaire`,
        `Diagnostic structurel`,
        `Étude topographique`,
        `Autre (à préciser)`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const soilStudyDoneOptions = [
        `Oui, je souhaite un complément ou une vérification`,
        `Non, c'est une première demande`,
        `Je ne sais pas`,
    ].map((v) => ({ label: v, value: v, key: v }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.laboratoireBtp.projectType}
        class=""
        let:field
        let:id
        label={`Quel type de projet souhaitez-vous étudier ?`}
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @4xl:grid-cols-2 gap-x-8"
            choices={projectTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.laboratoireBtp.projectStage}
        class=""
        let:field
        let:id
        label={`À quelle étape se trouve votre projet ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={projectStageOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.laboratoireBtp.serviceTypes}
        class=""
        let:field
        let:id
        label={`Quels types de prestations recherchez-vous ?`}
        helpLabel="Maximum 3 choix"
    >
        <PrettyChoiceMultiple
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @4xl:grid-cols-2 gap-x-8"
            choices={serviceTypesOptions}
            max={3}
        />
    </Row>

    <Row
        {form}
        field={fields.laboratoireBtp.soilStudyDone}
        class=""
        let:field
        let:id
        label={`Avez-vous déjà réalisé une étude de sol ou des tests ?`}
    >
        <Select
            {form}
            {id}
            {field}
            required={false}
            showChevron
            options={soilStudyDoneOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin, soyez le plus précis dans votre demande de devis"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin, soyez le plus précis dans votre demande de devis`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
